export default __webpack_public_path__ + "static/media/2126.386214c9.png";